"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TextWithSyllabification = _interopRequireDefault(require("../TextWithSyllabification/TextWithSyllabification"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-confirmationPage {\n  display: flex;\n  flex-direction: column;\n  max-width: 66rem;\n  margin: auto; }\n  .sia-confirmationPage .faqTop {\n    display: flex;\n    justify-content: center; }\n    .sia-confirmationPage .faqTop .container {\n      max-width: 492px; }\n\n@media (max-width: 66rem) {\n  .sia-confirmationPage .faqTop .container {\n    max-width: 452px;\n    padding-inline: 24px; } }\n";
  const fileName = "SIAConfirmationPage_SIAConfirmationPage";
  const element = document.querySelector("style[data-sass-component='SIAConfirmationPage_SIAConfirmationPage']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const SIAConfirmationPage = _ref => {
  let {
    title,
    lead,
    lang
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-faq"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "faqTop sia-margin-05-top"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "sia-text-12 sia-margin-02-bottom"
  }, title), /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, {
    lang: lang,
    className: "sia-text-10 sia-margin-02-bottom"
  }, lead))));
};
SIAConfirmationPage.propTypes = {
  lead: _propTypes.default.string.isRequired,
  lang: _propTypes.default.string.isRequired,
  title: _propTypes.default.string.isRequired
};
var _default = exports.default = SIAConfirmationPage;